module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price"
  }, [_vm._v("от"), _c('b', [_vm._v(_vm._s(_vm.priceFormatted)), _c(_vm.currencyTag, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69722b22","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/components/Price.vue
// module id = dc3b439fb89fc1ea1b2a
// module chunks = 89